import { render, staticRenderFns } from "./selectYear.vue?vue&type=template&id=67fea265&scoped=true&"
import script from "./selectYear.vue?vue&type=script&lang=js&"
export * from "./selectYear.vue?vue&type=script&lang=js&"
import style0 from "./selectYear.vue?vue&type=style&index=0&id=67fea265&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fea265",
  null
  
)

export default component.exports